import styled from 'styled-components';
import { parseConcepts, getEventLinks, conceptColor } from './eventUtils';

const Link = ({link, label}) => {
  return (
    <>
      {link && (
        <StyledLink href={link} target="_blank" rel="noopener noreferrer">
          {label}
        </StyledLink>
      )}
    </>
  );
};

const TableRow = ({event}) => {
  const concepts = parseConcepts(event);
  const links = getEventLinks(event);

  return (
    <RowWrapper>
      <TableCell className='event-title'>{event.title}</TableCell>
      <TableCell className='event-concepts'>
        {concepts.map(concept => (
          <span
            key={concept}
            style={{
              marginRight: '4px',
              borderRadius: '4px',
              padding: '2px 4px',
              backgroundColor: conceptColor(concept),
            }}
          >
            {concept}
          </span>
        ))}
      </TableCell>
      <TableCell className='event-type'>
        <LinksWrapper>
          <Link link={links.assignment} label="Assignment" />
          <Link link={links.example} label="Example" />
          <Link link={links.solution} label="Solution" />
          <Link link={links.slides} label="Slides" />
          <Link link={links.handout} label="Handout" />
        </LinksWrapper>
      </TableCell>
    </RowWrapper>
  );
};

export const EventsTable = ({weeks}) => {
  return (
    <StyledTable>
      <thead>
        <tr>
          <TableHeader>Name</TableHeader>
          <TableHeader>New Concepts</TableHeader>
          <TableHeader>Links</TableHeader>
        </tr>
      </thead>
      <tbody>
        {[...weeks].reverse().flatMap(week =>
          [...week.days].reverse().flatMap(day => {
            const sortedEvents = [...day.events]
              .filter(
                event => event.type !== 'break',
              )
              .sort((a, b) => a.start - b.start); // sort by 'start' field
            return (
              <>
              {
                sortedEvents.length > 0 && (
                  <tr key={day.date}>
                    <TableCell colSpan={3}>
                      <strong>{day.label}</strong>
                    </TableCell>
                  </tr>
                )
              }
                {sortedEvents.map(event => {
                  const assignmentId = event.id;

                  return <TableRow key={assignmentId} event={event} />;
                })}
              </>
              )
          }),
        )}
      </tbody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  font-family: Arial, sans-serif;
  font-size: 0.95rem;
  color: #1a1a1a;
  border-radius: 2px;
  overflow: hidden;
  outline: 1px solid rgba(0, 0, 0, 0.08);
`;

const TableHeader = styled.th`
  background-color: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
`;

const RowWrapper = styled.tr`
  &:hover {
    background-color: #f8f8f8;
  }
`;

const TableCell = styled.td`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
`;

const StyledLink = styled.a`
  &:hover {
    opacity: 0.8;
  }
`;

const LinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
